import { GameData } from "./game-data.js";

export default class ShipStatsVector {
    constructor() {
        this.attack = 0;
        this.structure = 0;
        this.armor = 0;
        this.shield = 0;
        this.thrust = 0;
        this.repair = 0;
        this.cargo = 0;
        this.thread = 0;
    }

    _addStatsVectorSparse(other, scale) {
        if (!scale) scale = 1.0;
        if (other.attack) this.attack += other.attack * scale;
        if (other.structure) this.structure += other.structure * scale;
        if (other.armor) this.armor += other.armor * scale;
        if (other.shield) this.shield += other.shield * scale;
        if (other.thrust) this.thrust += other.thrust * scale;
        if (other.repair) this.repair += other.repair * scale;
        if (other.cargo) this.cargo += other.cargo * scale;
        if (other.thread) this.thread += other.thread * scale;
    }

    _floor() {
        this.attack = Math.floor(this.attack);
        this.structure = Math.floor(this.structure);
        this.armor = Math.floor(this.armor);
        this.shield = Math.floor(this.shield);
        this.thrust = Math.floor(this.thrust);
        this.repair = Math.floor(this.repair);
        this.cargo = Math.floor(this.cargo);
        this.thread = Math.floor(this.thread);
        return this;
    }

    initFromConfiguration(ship_config) {
        for (let i = 0; i < GameData.SHIP_TECHNOLOGIES.length; i++) {
            let tech = GameData.SHIP_TECHNOLOGIES[i];
            if (ship_config[tech.id] > 0 && Number.isInteger(Number(ship_config[tech.id]))) {
                let level = Number(ship_config[tech.id]);
                let properties = tech.properties(level);
                this._addStatsVectorSparse(properties, 1.0);
            }
        }

        if (this.repair === 0) {
            this.repair = 5; // Every ship has a mechanic :)
        }

        this.thread += this.structure;
        switch (ship_config.role) {
            case "tank":
                this.thread *= 2;
                break;
            case "civil":
                this.thread *= 0.5;
                break;
            default: // Nothing fft
        }
        this.thread = Math.max(this.thread, 1);

        return this._floor();
    }
}
